import React, { useEffect, useState } from 'react';
import { RootState } from '../../../../redux/store';
import { changeRule } from '../../../../redux/actions/RuleActions';
import { Syntax } from '@trlogic/ui-pack';
import { useSelector, useDispatch } from 'react-redux';
import MappingBuilderComponent from './MappingBuilderComponent';

interface MappingComponentProps {
  variableName?: string;
}

function MappingComponent({ variableName }: MappingComponentProps) {
  const [expression, setExpression] = useState<Syntax | undefined>(undefined);
  const { rule } = useSelector((state: RootState) => state.rule);
  const dispatch = useDispatch();

  useEffect(() => {
    openExpression();
  }, []);

  const openExpression = () => {
    const expression: Syntax | undefined = rule.rule;
    setExpression(expression);
  };

  const onChangeCondition = (expression: Syntax) => {
    setExpression(expression);
    rule.rule = expression;
    dispatch(changeRule(rule));
  };

  if (expression) {
    return (
      <div className='flex flex-col gap-2 mt-5 w-full'>
        <h3 className='text-primary text-md font-medium'>Mapping</h3>
        <MappingBuilderComponent onChange={onChangeCondition} variableName={variableName || ''} />
      </div>
    );
  } else return null;
}

export default MappingComponent;
